import Tooltip from '../components/Tooltip.vue'

export default ({ Vue }) => {
  Vue.component('tooltip', Tooltip)
}
